module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/administrative/maja-okulus-9b223c76b081ba60046b4afb17562edc.png";